# This gets automatically populated bij gulp

exports.date = 1475152514
exports.branch = "master"
exports.hash = "9b99341"
exports.build = 2256
exports.version = "#{exports.branch}/#{exports.hash}"



/** WEBPACK FOOTER **
 ** ./build/Version.coffee
 **/